import { Injectable, inject, signal } from '@angular/core';
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class WoConnectivityService {
  readonly online = signal(true);

  private started = false;

  async start(): Promise<void> {
    if (this.started) {
      return;
    }
    this.started = true;
    try {
      const status = await Network.getStatus();
      this.online.set(status.connected);
    } catch {
      this.online.set(typeof navigator !== 'undefined' ? navigator.onLine : true);
    }
    try {
      await Network.addListener('networkStatusChange', (status) => {
        this.online.set(status.connected);
      });
    } catch {
      if (typeof window !== 'undefined') {
        window.addEventListener('online', () => this.online.set(true));
        window.addEventListener('offline', () => this.online.set(false));
      }
    }
  }

  isNative(): boolean {
    return Capacitor.isNativePlatform();
  }
}
